import { TagSearchActionTypes } from './constants';
const INITIAL_STATE = { tagSearchData: [], loading: false };
const tagSearchDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TagSearchActionTypes.TAG_SEARCH_DATA_LOADING:
            return { tagSearchData: state.tagSearchData, loading: true };
        case TagSearchActionTypes.TAG_SEARCH_DATA_SUCCESS:
            return { tagSearchData: action.payload, loading: false };
        case TagSearchActionTypes.TAG_SEARCH_DATA_ERROR:
            return { tagSearchData: action.payload, loading: false };
        default:
            return state;
    }
};
export { tagSearchDataReducer };
